import angular from "angular";
import designStoreDialogTemplate from './DesignStoreDialog.html';
import './DesignStoreDialog.css';

/*******************************************************************************
 * @ngdoc   service
 * @mdule   StoreAdmin
 * @name    StoreAdmin.service:DesignStoreDialog
 *
 * @description
 * Opens a modal dialog with an iframe loaded with the organization webstore.
 * Controls at the top of the dialog allow changes to the webstore configuration.
 * Messages are posted to the iframe with these changes and the iframe is updated
 * in real-time. Ok button commits changes but does not save them. Changes will
 * be saved with the Save Changes button on the app page.
 *******************************************************************************/
/* @ngInject */ export function DesignStoreDialogService($uibModal) {
  /*****************************************************************************
   * @ngdoc    method
   * @name     show
   * @methodOf csm.books.StoreAdmin.service:DesignStoreDialog
   * @param    {Object} store  Store configuration object
   * @description
   * Displays a modal to manage the store UI settings for the provided store
   * object. The size of the modal displayed is based on the window size.
   *****************************************************************************/
  this.show = function (store, url) {
    $uibModal.open({
      animation: true,
      template: designStoreDialogTemplate,
      resolve: { store: () => store, design: () => ({ url: url }) },
      size: window.innerWidth > 900 ? 'lg' : 'md',
      controller: controller,
      controllerAs: '$ctrl'
    });
  };

  /*------------*/
  /* Controller */
  /*------------*/
  /* @ngInject */ function controller(
    $injector,
    $sce,
    $scope,
    $uibModalInstance,
    design,
    store,
    SERVER,
    Tools
  ) {
    var $svcs = {
      $ctrl: this,
      $scope: $scope,
      $uibModalInstance: $uibModalInstance
    };
    var $ctrl = Object.assign(this, {
      store: store,
      iframeWindow: undefined,
      announcement: store.config.announcement,
      layout: angular.copy(store.config.storeDesign),
      source: $sce.trustAsResourceUrl(design.url),

      onStoreLoad: $injector.invoke(onStoreLoad, null, $svcs),
      close: $injector.invoke(close, null, $svcs)
    });
  }
}

/***************************************************************************
 * onStoreLoad
 *
 * Applies the store colors to the web store in the design store modal.
 ***************************************************************************/
/* @ngInject */ function onStoreLoad($ctrl, $scope) {
  return function (event) {
    var iframeWindow = event.currentTarget.contentWindow;
    var applyCSS = () =>
      iframeWindow.postMessage(
        angular.extend({ eventType: 'css' }, $ctrl.layout),
        '*'
      );
    var applyGreeting = () =>
      iframeWindow.postMessage(
        { eventType: 'greeting', greeting: $ctrl.announcement },
        '*'
      );

    $scope.$watch('$ctrl.announcement', applyGreeting);
    $scope.$watch('$ctrl.layout', applyCSS, true);

    applyCSS();
    applyGreeting();
  };
}

/***************************************************************************
 * close
 *
 * Saves the store announcement and store colors and closes the modal.
 ***************************************************************************/
/* @ngInject */ function close($ctrl, $uibModalInstance) {
  return function () {
    $ctrl.store.config.announcement = $ctrl.announcement;
    angular.extend($ctrl.store.config.storeDesign, $ctrl.layout);

    $uibModalInstance.close();
  };
}
